'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _throttleDebounce = require('throttle-debounce');

var _throttleDebounce2 = _interopRequireDefault(_throttleDebounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InfiniteScroller = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(InfiniteScroller, _React$Component);

  function InfiniteScroller() {
    (0, _classCallCheck3.default)(this, InfiniteScroller);

    var _this = (0, _possibleConstructorReturn3.default)(this, (InfiniteScroller.__proto__ || (0, _getPrototypeOf2.default)(InfiniteScroller)).call(this));

    _this.handleWindowScroll = _throttleDebounce2.default.throttle(200, _this.handleWindowScroll.bind(_this));
    return _this;
  }

  (0, _createClass3.default)(InfiniteScroller, [{
    key: 'handleWindowScroll',
    value: function handleWindowScroll(ev) {
      if (document.body.clientHeight < window.innerHeight) return;

      if (window.pageYOffset + window.innerHeight * 2 >= document.body.clientHeight) {
        this.props.onLoadMore();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', this.handleWindowScroll);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleWindowScroll);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.disabled && nextProps.disabled) {
        window.removeEventListener('scroll', this.handleWindowScroll);
      } else if (this.props.disabled && !nextProps.disabled) {
        window.addEventListener('scroll', this.handleWindowScroll);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var className = this.props.className;


      var props = {};
      if (className) props.className = className;

      return _react2.default.createElement(
        'div',
        props,
        this.props.children
      );
    }
  }]);
  return InfiniteScroller;
}(_react2.default.Component), _class.propTypes = {
  children: _react2.default.PropTypes.element.isRequired,
  onLoadMore: _react2.default.PropTypes.func,
  disabled: _react2.default.PropTypes.bool,
  loaderComponent: _react2.default.PropTypes.element,
  className: _react2.default.PropTypes.string
}, _temp);
exports.default = InfiniteScroller;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/InfiniteScroller/InfiniteScroller.jsx
// module id = 2356
// module chunks = 0